import React, { useEffect, useState } from "react";
import {
  Getagencypatientdetails,
  GetpatientAllergy,
  GetpatientMedication,
} from "../../api/helper";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import AllergyVerify from "./AllergyVerify";
import MedicationVerify from "./MedicationVerify";
import { Button } from "./ReuseableComponent/alert";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ShowToast } from "../../helpers/ToastService";

const AllergiesMedications = ({ data, onComplete }) => {
  const [openModal, setOpenModal] = useState(null);
  const [allergyData, setAllergyData] = useState([]);
  const [medicationData, setMedicationData] = useState([]);
  const [info, setInfo] = useState(null);
  const handleSave = () => {
    onComplete?.(true);
  };

  const handleOpenModal = (modal) => {
    setOpenModal(modal);
  };

  const handleCloseModal = () => {
    setOpenModal(null);
  };

  const Getdata = async () => {
    try {
      const respo = await GetpatientAllergy(data?.patientId);
      setAllergyData(respo?.data?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const GetMedications = async () => {
    try {
      const respo = await GetpatientMedication(data?.patientId);
      setMedicationData(respo?.data?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const getDteails = async () => {
    const response = await Getagencypatientdetails(data?.pateintRequestId);
    setInfo(response.data.data);
  };

  useEffect(() => {
    getDteails();
    GetMedications();
    Getdata();
  }, []);
const handleDownloadPDF = () => {
  if (!allergyData.length && !medicationData.length) {
    ShowToast("No allergy or medication data found.");
    return;
  }

  const doc = new jsPDF();
  let y = 10;

  doc.setFontSize(16);
  doc.text("Patient Allergy and Medication Report", 14, y);
  y += 10;

  // Allergies Section
  if (allergyData.length > 0) {
    doc.setFontSize(14);
    doc.text("Allergies", 14, y);
    y += 6;

    const allergyRows = allergyData.map((item) => [
      item.Allergy,
      item.Code,
      new Date(item.Date).toLocaleDateString(),
      item.ClinicalStatus,
      item.VerificationStatus,
      item.Criticality,
      new Date(item.LastReactionDate).toLocaleDateString(),
      item.Kind,
      item.Severity,
      item.ManagementInstructions,
    ]);

    autoTable(doc, {
      startY: y,
      head: [
        [
          "Allergy",
          "Code",
          "Date",
          "Status",
          "Verification",
          "Criticality",
          "Last Reaction",
          "Kind",
          "Severity",
          "Management",
        ],
      ],
      body: allergyRows,
      styles: { fontSize: 8 },
    });

    y = doc.lastAutoTable.finalY + 10;
  }

  // Medications Section
  if (medicationData.length > 0) {
    doc.setFontSize(14);
    doc.text("Medications", 14, y);
    y += 6;

    const medicationRows = medicationData.map((item) => [
      item.Medication,
      item.Code,
      new Date(item.StartDate).toLocaleDateString(),
      new Date(item.EndDate).toLocaleDateString(),
      item.Action,
      item.Dose,
      item.Unit,
      item.Route,
      item.Frequency,
      item.Directions,
      item.Instructions,
    ]);

    autoTable(doc, {
      startY: y,
      head: [
        [
          "Medication",
          "Code",
          "Start Date",
          "End Date",
          "Action",
          "Dose",
          "Unit",
          "Route",
          "Frequency",
          "Directions",
          "Instructions",
        ],
      ],
      body: medicationRows,
      styles: { fontSize: 8 },
    });
  }

  const filename = `Allergies_Medications_${info?.firstName || "Patient"}.pdf`;
  doc.save(filename);
};

  return (
    <div className="basic-info-form">
      <h2>Allergy Meds Form</h2>
      <p className="form-description">
        Please complete the Basic Info form. All fields marked with * are
        required.
      </p>
      <>
        <div style={{ marginBottom: 20 }}>
          <h3 className="header_text_style">Allergies</h3>
          <button
            className="cta-button"
            type="button"
            onClick={() => handleOpenModal("allergy")}
            style={{ width: 128, alignSelf: "flex-start", display: "flex" }}
          >
            Add Allergy
          </button>
          <table className="table_verify" style={{ marginTop: 10 }}>
            <thead>
              <tr>
                <th>ALLERGY</th>
                <th>CODE</th>
                <th>RECORDED DATE</th>
                <th>CLINICAL STATUS</th>
                <th>VERIFICATION STATUS</th>
                <th>CRITICALITY</th>
                <th>LAST REACTION DATE</th>
                <th>REACTION KIND</th>
                <th>REACTION SEVERITY</th>
                <th>MANAGEMENT</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {allergyData.map((item) => (
                <tr key={item._id}>
                  <td>{item.Allergy}</td>
                  <td>{item.Code}</td>
                  <td>{new Date(item.Date).toLocaleDateString()}</td>
                  <td>{item.ClinicalStatus}</td>
                  <td>{item.VerificationStatus}</td>
                  <td>{item.Criticality}</td>
                  <td>
                    {new Date(item.LastReactionDate).toLocaleDateString()}
                  </td>
                  <td>{item.Kind}</td>
                  <td>{item.Severity}</td>
                  <td>{item.ManagementInstructions}</td>
                  <td>
                    <button
                      className="cta-button"
                      style={{ padding: "4px 8px" }}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
            {/* <Button
                style={{ marginTop: 10 }}
                className="w-full bg-[#BC9C22] hover:bg-[#9e7f1f]"
                onClick={handleDownloadPDF}
              >
                Download PDF
              </Button> */}
        </div>
        <div>
          <h3 className="header_text_style">Medications</h3>
          <button
            className="cta-button"
            type="button"
            onClick={() => handleOpenModal("medication")}
            style={{ width: 158, alignSelf: "flex-start", display: "flex" }}
          >
            Add Medication
          </button>
          <table className="table_verify" style={{ marginTop: 10 }}>
            <thead>
              <tr>
                <th>MEDICATION</th>
                <th>CODE</th>
                <th>START DATE</th>
                <th>END DATE</th>
                <th>ACTION</th>
                <th>DOSE</th>
                <th>UNIT</th>
                <th>ROUTE</th>
                <th>FREQUENCY</th>
                <th>STATUS</th>
                <th>INSTRUCTIONS</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {medicationData.map((item) => (
                <tr key={item._id}>
                  <td>{item.Medication}</td>
                  <td>{item.Code}</td>
                  <td>{new Date(item.StartDate).toLocaleDateString()}</td>
                  <td>{new Date(item.EndDate).toLocaleDateString()}</td>
                  <td>{item.Action}</td>
                  <td>{item.Dose}</td>
                  <td>{item.Unit}</td>
                  <td>{item.Route}</td>
                  <td>{item.Frequency}</td>
                  <td>{item.Directions}</td>
                  <td>{item.Instructions}</td>
                  <td>
                    <button
                      className="cta-button"
                      style={{ padding: "4px 8px" }}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
            <Button
                style={{ marginTop: 10 }}
                className="w-full bg-[#BC9C22] hover:bg-[#9e7f1f]"
                onClick={handleDownloadPDF}
              >
                Download PDF
              </Button>
        </div>
      </>
      <button
        className="cta-button"
        id="completeForm"
        type="button"
        style={{ marginTop: 20, width: "100%" }}
        onClick={handleSave}
      >
        Save
      </button>
      <>
        {openModal === "allergy" && (
          <AllergyVerify
            handleCloseModal={handleCloseModal}
            Getdata={Getdata}
            info={info}
          />
        )}

        {openModal === "medication" && (
          <MedicationVerify
            handleCloseModal={handleCloseModal}
            Getdata={GetMedications}
            info={info}
          />
        )}
      </>
    </div>
  );
};

export default AllergiesMedications;
